
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buildings",
      function () {
        return require("private-next-pages/buildings/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buildings"])
      });
    }
  